import { FillFormPayQuote }	from "../_components/_pay-quote-fill-form";
import { PayQuoteDatepicker }	from "../_components/_pay-quote-datepicker";

window.$ = jQuery;

$( document ).ready( function () {
	FillFormPayQuote();
	PayQuoteDatepicker();
} );
